import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class CartaoService {

  constructor(
    private http: HttpClient
  ) { }

  adicionarCartao(data) {
    return this.http
      .post(urls.apiBase + '/Cartoes/Adicionar', data);
  }

  removerCartao(id) {
    return this.http
      .delete(urls.apiBase + '/Cartoes/Remover?id=' + id);
  }

  obterCartoesPorClienteId(clienteId) {
    return this.http
      .get(urls.apiBase + '/Cartoes/ObterPorClienteId?clienteId=' + clienteId);
  }

  obterBandeira(numero, contaId) {
    return this.http
      .get(urls.apiBase + '/Cartoes/Consultar?numero=' + numero + '&contaId=' + contaId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cartao/cartao.service.ts